import React, { useState } from "react";
import {
  Card,
  CardContent,
  Typography,
  Grid,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  TableContainer,
  Chip,
  useMediaQuery,
} from "@mui/material";
import { useTheme } from "@emotion/react";
import DesktopView from "./DesktopView";
import MobileView from "./MobileView";

const ZonalManagerDashboardComponent = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isMobileOrPhablet = useMediaQuery("(max-width: 1080px)");

  return (
  <>
 {isMobileOrPhablet ? (<MobileView></MobileView>) : (<DesktopView></DesktopView>)}
  </>
);
};

export default ZonalManagerDashboardComponent;
